import validate from "/root/injective/injective-dmm-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/root/injective/injective-dmm-v2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  maintenance: () => import("/root/injective/injective-dmm-v2/middleware/maintenance.ts")
}